import { create } from "zustand";
import { Spec } from "../models/specs";
import { SpecsFiltersType } from "../components/Specs/SpecsFilterList";

type SpecSpaceState = {
    currentParams?: Record<string, any>;
    setCurrentParams: (params: Record<string, any>) => void;
    filteredSpecs: Spec[];
    setFilteredSpecs: (specs: Spec[] | ((prev: Spec[]) => Spec[])) => void;
    activeTab: string;
    setActiveTab: (tab: string) => void;
    loading: boolean;
    setLoading: (v: boolean) => void;
    err: string;
    setErr: (v: string) => void;
    showFilters: boolean;
    setShowFilters: (v: boolean) => void;
    currentFilters: SpecsFiltersType;
    setCurrentFilters: (filters: SpecsFiltersType) => void;
    selectedProduct: string;
    setSelectedProduct: (v: string) => void;
    searchText: string;
    setSearchText: (v: string) => void;

};



export const useSpecSpaceStore = create<SpecSpaceState>((set) => ({
    currentParams: undefined,
    setCurrentParams: (params) => set({ currentParams: params }),
    filteredSpecs: [],
    setFilteredSpecs: (specs) =>
        set((state) => ({
            filteredSpecs:
                typeof specs === "function" ? specs(state.filteredSpecs) : specs,
        })),
    activeTab: "all",
    setActiveTab: (tab) => set({ activeTab: tab }),
    loading: false,
    setLoading: (v) => set({ loading: v }),
    err: "",
    setErr: (v) => set({ err: v }),
    showFilters: false,
    setShowFilters: (v) => set({ showFilters: v }),
    createFormOpen: false,
    currentFilters: {
        verticals: [],
        payoutRange: { min: "", max: "" },
        state_list: [],
        payout_type: "",
        product: []

    },
    setCurrentFilters: (filters) => set({ currentFilters: filters }),
    selectedProduct: "All",
    setSelectedProduct: (v) => set({ selectedProduct: v }),
    searchText: "",
    setSearchText: (v) => set({ searchText: v })
}));
